<div class="c-navigation c-navigation--toolbar">
  <maced-toolbar toolbarId="Toolbar" hamburgerUrl="/toolbar" hamburgerTooltip="Menu"
    [hamburgerQueryParams]="{ isHamburgerClicked: true }" [toolbarMenuList]="toolbarMenuList">
  </maced-toolbar>
</div>